/**
 * A function that maps a component's props to a single string.
 * The props must use the logic like so:
 * - a string prop type will map it's VALUE to a css class
 * - a boolean will map the property NAME to a class
 *
 * @param props Any component Props
 * @returns string
 */
export const mapClasses = (props: Record<string, any>): string => {
  const classes = Object.entries(props).map(([key, type]) => {
    switch (typeof type) {
      case 'string':
        return props[key];
      case 'boolean':
        return props[key] ? key : null;
      default:
        return null;
    }
  });
  return classes.filter((c) => !!c).join(' ');
};
